import type React from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { usePetitionDetails } from '../hooks/petitionDetails/petitionDetails';

export const HeadingContainer: React.FC = () => {
	const details = usePetitionDetails();
	return (
		<Box py={24}>
			<Box>
				<Heading
					as="h1"
					pt={0}
					breakWord
					data-qa="petition-title"
					sx={{
						textAlign: 'left',
						lineHeight: ['52px', null, '56px'],
						fontSize: [40, null, 48],
					}}
				>
					{details.ask}
				</Heading>
			</Box>
		</Box>
	);
};
